import { render } from "./accessorySelect.vue?vue&type=template&id=2547293f&scoped=true"
import script from "./accessorySelect.vue?vue&type=script&lang=js"
export * from "./accessorySelect.vue?vue&type=script&lang=js"

import "./accessorySelect.vue?vue&type=style&index=0&id=2547293f&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2547293f"]])

export default __exports__